import { Box } from "@mui/material";
import { t } from "i18next";

export const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};
export const PreferenceTabs = [
  {
    label: t("preferences.vaultStatusReport"),
    value: "vaultStatusReport"
  },
  {
    label: t("preferences.preferences"),
    value: "Preferences"
  }
];

export const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
};
